export default "dist/images/block-feature-grid-zigzag.d66da6e.png";